import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";

import Typography from "@/shared/components/Typography/Typography";

import { remToPx } from "@/shared/utils/viewmode";
import {
  selectorMainTreeBibleVersions,
  selectorMainTreeLangMap,
} from "@/shared/store/mainTree/selectors";
import { settingsActions } from "@/store/actions";
import { SETTING } from "@/shared/utils/settings/constants";
import { useReaderContext } from "@/components/Reader/Reader";
import { getBookIdWithPrefix } from "@/shared/utils/content/content";

import sassVariables from "@/styles/variables.module.scss";

const Popup = dynamic(() => import("@/shared/components/Popup/Popup"), {
  ssr: false,
});

const TranslationsPopup = ({
  indexPanel,
  isShown,
  anchorEl,
  contentWrapElRect,
  onHidePopup,
  listTranslations,
  className,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const langMap = useSelector(selectorMainTreeLangMap);
  const bibles = useSelector(selectorMainTreeBibleVersions);

  const { openSecondPanel } = useReaderContext();

  return (
    <Popup
      contentProps={{
        className,
      }}
      maxHeight={remToPx(sassVariables.readerTranslationsPopupHeight)}
      isShown={isShown}
      anchorEl={anchorEl}
      boundaryRect={contentWrapElRect}
      onHide={onHidePopup}>
      {({ hide }) => (
        <ul>
          {listTranslations?.length ? (
            listTranslations.map(({ para_id: paraId, refcode, lang }) => {
              const langLabel = langMap[lang] || lang;
              const bookId = getBookIdWithPrefix(paraId);
              const book = bibles.find((bible) => bible.id === bookId);
              const refcodeLabel = refcode || (book ? book.code + " —" : "");

              return (
                <li
                  onClick={(e) => {
                    openSecondPanel(paraId);

                    if (indexPanel === 0) {
                      dispatch(settingsActions.updateSettings(SETTING.syncReader.id, false));
                    }

                    hide(e);
                  }}
                  key={paraId}>
                  {refcodeLabel}&nbsp;{langLabel}
                </li>
              );
            })
          ) : (
            <Typography variant={Typography.variant.body4}>{t("placeholderForMyLangs")}</Typography>
          )}
        </ul>
      )}
    </Popup>
  );
};

TranslationsPopup.propTypes = {
  isShown: PropTypes.bool,
  anchorEl: PropTypes.any,
  contentWrapElRect: PropTypes.object,
  onHidePopup: PropTypes.func,
  listTranslations: PropTypes.array,
  className: PropTypes.string,
};

export default TranslationsPopup;
